import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ShiftStatus } from '@app/interfaces/booking';
import { Preferences } from '@capacitor/preferences';
import { Key } from '@app/interfaces/storage';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public currentDevice = new BehaviorSubject(undefined as any);
  public upcoming;
  public selectedTransport;
  public selectedBooking;
  public maintenanceData = new BehaviorSubject(undefined as any);
  public showMaintenance = new BehaviorSubject(false);
  public linkedAccount = new BehaviorSubject(undefined as any);
  public bookingNavigate = new BehaviorSubject(false);
  public subUser = new BehaviorSubject(undefined as any);
  public providers = new BehaviorSubject(undefined as any);
  public siteInfo = new BehaviorSubject(undefined as Array<any>);
  public shiftStatus = new BehaviorSubject(undefined as Array<ShiftStatus>);
  public fcmToken = new BehaviorSubject(undefined as any);
  public accessToken = new BehaviorSubject('');
  public refreshToken = new BehaviorSubject('');
  public manageBookingEnable = new BehaviorSubject(false);
  public ENV = '';
  public isRefreshing = false;

  constructor(private router: Router) {
      this.init();
    }

      // get current device in localstorage
  public async getDevice(): Promise<any> {
    const device = JSON.parse((await Preferences.get({key: 'device'})).value);
    if (device) {
      this.ENV = device.ENV;
    }
    return device;
  }

  async init() {
    this.currentDevice.next(await this.getDevice());
  }

  /**
   * storing data in local storage
   * @param data data to store
   * @param key key e.g 'device', 'upcoming'
   */
  public setLocal(data, key: Key): Promise<any> {
    this.updateBS(key, data);
    return Preferences.set({key, value: JSON.stringify(data)});
  }


  /**
   * get local storage value
   * @param key key data to access e.g 'upcoming', 'divece'
   */
  public getLocal(key: Key): Promise<any> {
    return Preferences.get({key}).then((result) => {
      const data = JSON.parse(result.value);
      this.updateBS(key, data);
      return data;
    });
  }

  private updateBS(key: Key, data: any) {
    switch (key) {
      case 'upcoming':
        this.upcoming = data;
        break;
      case 'linkedAccount':
        this.linkedAccount.next(data);
        break;
      case 'subUser':
        this.subUser.next(data);
        break;
      case 'providers':
        this.providers.next(data);
        break;
      case 'device':
        this.currentDevice.next(data);
        break;
      case 'accessToken':
        this.accessToken.next(data);
        break;
      case 'refreshToken':
        this.refreshToken.next(data);
        break;
      case 'siteInfo':
        this.siteInfo.next(data);
        break;
      case 'fcmToken':
        this.fcmToken.next(data);
        break;
    }
  }

  // handle logout, clearing all global variable value
  public logout() {
    return Preferences.clear().then(async () => {
      await this.router.navigate(['/signup'], { replaceUrl: true });
      this.currentDevice.next(null);
      this.accessToken.next(null);
      this.refreshToken.next(null);
      this.linkedAccount.next(null);
      this.subUser.next(null);
      this.upcoming = null;
      this.providers.next(null);
      this.maintenanceData.next(null);
      this.showMaintenance.next(false);
    });
  }
}
